/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EnabledParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('enabled')],
]);
export class Enabled extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EnabledParser.decode(input).map(res => new Enabled(res));
    }
    static unsafeDecode(input) {
        return Enabled.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledParser.encode(data);
    }
    static schema() {
        return EnabledParser.schema();
    }
}
